import { VirtualScrollerDesignTokens } from '@primeuix/themes/types/virtualscroller';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/virtualscroller/index.ts
const vs = componentCommon.virtualscroller;

export const VirtualscrollerTelekomDT: VirtualScrollerDesignTokens = {
  loader: {
    mask: {
      background: t(vs.loader.mask.background),
      color: t(vs.loader.mask.color),
    },
    icon: {
      size: t(vs.loader.icon.size),
    },
  },
};
